import axiosClient from "../axiosClient";

const route = "/subscription";

export const getAllSubscriptions = async (params = {}) => {
  try {
    const response = await axiosClient.get(
      `${route}/getAll`,
      {
        params: {
          ...params,
        },
      }
    );

    return response;
  } catch (error) {
    console.error(error);
  }
};